import * as React from "react";
const SvgIcMiniWin = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 7, width: 14, height: 1, rx: 0.5, fill: "#A1A7B2" }));
export default SvgIcMiniWin;
